module.exports = __webpack_public_path__ + "img/ico-atendimento.4a873fe2.svg";